import React, { useMemo } from 'react';
import { ChatWr, GameSceneCode } from '@pascal/pascal-core';
import RightColumn from '../common/rightColumn';
import LeftColumn from '../common/leftColumn';
import StatisticsWr from '../common/leftColumn/resultsWrapper/statisticsWr';
import { PopupsWrapper } from '../common/popUps/wrapper';

const ActiveGameScene = ({ gameScene }) => {
  const { Results, Bets, Info, Chat, Statistics } = GameSceneCode;
  const GameSceneComponents = useMemo(
    () => ({
      [Results]: LeftColumn,
      [Bets]: RightColumn,
      [Statistics]: StatisticsWr,
      [Info]: PopupsWrapper,
      [Chat]: ChatWr,
    }),
    []
  );

  if (gameScene) {
    const Component = GameSceneComponents[GameSceneCode[gameScene]];
    return <Component />;
  }
  return <></>;
};

export default ActiveGameScene;
